import { render, staticRenderFns } from "./storeOrderCartManage.vue?vue&type=template&id=227d8443&scoped=true"
import script from "./storeOrderCartManage.vue?vue&type=script&lang=js"
export * from "./storeOrderCartManage.vue?vue&type=script&lang=js"
import style0 from "./storeOrderCartManage.vue?vue&type=style&index=0&id=227d8443&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d8443",
  null
  
)

export default component.exports